<template>
  <!-- Listener pour l'ouverture du dialog de conseil -->
  <VBusHelper
    :reactOn="'CONTACT_ADVISOR_OPEN'"
    :handler="handleOpen"
  />

  <DialogComponent ref="dialog" type="modal">
    <div class="space-y-6 max-w-lg mx-auto">
      <!-- Header -->
      <div class="text-center mb-6">
        <div class="inline-block p-4 rounded-full bg-blue-100 mb-4">
          <ColorImg
            src="/images/icons/message-square.svg"
            class="bg-blue-600 w-12 h-12"
          />
        </div>
        <h3 class="text-2xl font-bold text-gray-800 mb-2">
          Parler avec un conseiller
        </h3>
        <p class="text-gray-600">
          Laissez-nous vos coordonnées et un conseiller vous recontactera sous 24h.
        </p>
      </div>

      <!-- Formulaire -->
      <form v-if="!isSuccess" @submit.prevent="handleSubmit" class="space-y-5">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Nom complet</label>
            <input
              v-model="form.fullName"
              type="text"
              required
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
              placeholder="Votre nom"
            />
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                v-model="form.email"
                type="email"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                placeholder="votre@email.com"
              />
            </div>
            <div>
              <label class="block text-sm font-medium text-gray-700 mb-1">Téléphone</label>
              <input
                v-model="form.phone"
                type="tel"
                required
                class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                placeholder="+XXX XX XX XX"
              />
            </div>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Comment pouvons-nous vous aider ?</label>
            <textarea
              v-model="form.message"
              rows="3"
              class="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all resize-none"
              placeholder="Votre message ou question..."
            ></textarea>
          </div>
        </div>

        <div class="pt-4">
          <button
            type="submit"
            :disabled="isSending"
            class="w-full bg-blue-600 text-white py-4 rounded-xl font-bold text-lg hover:bg-blue-700 transition-all disabled:opacity-50 shadow-lg shadow-blue-200 flex items-center justify-center gap-3"
          >
            <div v-if="isSending" class="w-6 h-6 border-4 border-white/30 border-t-white rounded-full animate-spin"></div>
            <span v-else>Envoyer ma demande</span>
          </button>
        </div>
      </form>

      <!-- Message de succès -->
      <div v-else class="py-12 text-center space-y-6">
        <div class="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <ColorImg src="/images/icons/check.svg" class="bg-green-600 w-10 h-10" />
        </div>
        <div>
          <h4 class="text-2xl font-bold text-gray-800 mb-2">Message envoyé !</h4>
          <p class="text-gray-600">
            Merci <strong>{{ form.fullName }}</strong>. Un conseiller reviendra vers vous très prochainement par email ou téléphone.
          </p>
        </div>
        <button @click="closeDialog" class="px-8 py-3 bg-gray-800 text-white rounded-xl font-semibold hover:bg-black transition-all">
          Fermer
        </button>
      </div>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref, reactive } from 'vue';
import { sendToTelegram } from '@/app/services/telegramService';

const dialog = ref(null);
const isSending = ref(false);
const isSuccess = ref(false);

const form = reactive({
  fullName: '',
  email: '',
  phone: '',
  message: ''
});

const handleOpen = (payload) => {
  isSuccess.value = false;
  isSending.value = false;
  
  if (payload?.customerInfo) {
    form.fullName = payload.customerInfo.fullName || '';
    form.email = payload.customerInfo.email || '';
    form.phone = payload.customerInfo.phone || '';
  }

  dialog.value.show();
};

const handleSubmit = async () => {
  isSending.value = true;
  try {
    const success = await sendToTelegram('📞 DEMANDE DE CONSEIL', {
      ...form,
      source: 'Formulaire "Parler avec un conseiller"'
    });

    if (success) {
      isSuccess.value = true;
    } else {
      alert('Une erreur est survenue lors de l\'envoi. Veuillez réessayer.');
    }
  } catch (error) {
    console.error('Contact advisor error:', error);
    alert('Erreur technique.');
  } finally {
    isSending.value = false;
  }
};

const closeDialog = () => {
  dialog.value.hide();
  form.message = '';
};
</script>
